import { HttpClient, HttpHeaders } from '@angular/common/http'
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ElementRef
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import * as XLSX from 'xlsx'
import { MatDatepickerInputEvent } from '@angular/material/datepicker'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { NavigationEnd, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { fromEvent, merge, Observable, of as observableOf } from 'rxjs'
import {
  catchError,
  debounceTime,
  filter,
  map,
  startWith,
  switchMap
} from 'rxjs/operators'
import {
  Lector,
  RequestContainers,
  ResponseUSer,
  ResponseViewContainers
} from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { ContainerListService } from 'src/app/_services/container-list.service'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component'
import { MatTableDataSource } from '@angular/material/table'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmContainerItemsComponent } from '../modal/confirm-container-items/confirm-container-items.component'


@Component({
  selector: 'app-containers-client',
  templateUrl: './containers-client.component.html',
  styleUrls: ['./containers-client.component.css']
})
export class ContainersClientComponent implements  OnInit, AfterViewInit, OnDestroy {
  isLDT=true;
  viewEditItemsContainer=false;
  EditItemsContainerID=0;
  viewTable=false;
  arrayItemsContainer=[];
  mySubscription: any
  FormItemsContainer: FormGroup
  currentUser: ResponseUSer
  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  editar = false
  update: any
  SelectEstatus: any
  CustomerView = []
  ContainerForm: FormGroup
  toppings = new FormControl()

  ArrayEstatusContenedor = []
  newContainer: RequestContainers
  selected: any
  checked = true
  actived = true
  displayedColumns: string[] = [
    'Options',
    'Customer',
    'Container',
    'References',
    'Arrived',
    'Empty',
    'Departed',
    'Location',
    'Pieces',
    'Available',
    'Status',
    'Active',
    'Notes'
  ]
  ContainerListService: ContainerListService | null
  data: ResponseViewContainers[] = []
  datasourceConteiner: MatTableDataSource<ResponseViewContainers>
  @ViewChild('tablePaginator') paginatorSearch: MatPaginator
  @ViewChild('tablematSort') sortSearch: MatSort
  resultsLength = 0
  isLoadingResults = true
  isRateLimitReached = false
  active = 0
  From: Date
  To: Date
  ViewTab = new FormControl(0)
  fecha = new Date()
  date = new FormControl(
    new Date(this.fecha.setMonth(this.fecha.getMonth() + 1))
  )
  date2 = new FormControl(
    new Date(this.fecha.setMonth(this.fecha.getMonth() - 2))
  )
  dateArrived = new FormControl(new Date())
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatSort) sort: MatSort
  th: any
  events: string[] = []
  constructor (
    private _httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(events => {
        this.authenticationService.currentUser.subscribe(
          x => (this.currentUser = x)
        )
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd')
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true
      }
    })
    this.CustomerView = []
    this.ArrayEstatusContenedor = []
    this.arrayItemsContainer=[];

if (this.authenticationService.currentUserValue.company=='LDT20') {
  this.isLDT=false;
}

  }

  ngOnInit (): void {
    this.FormItemsContainer = this.formBuilder.group({
      itemNumber: [''],
      quantity: [1,Validators.required],
      pallet: [1,Validators.required],
      weight: [1],
      location: [''],
      proNumber:[""]
    })
    this.To = this.date.value
    this.From = this.date2.value
    this.ContainerForm = this.formBuilder.group({
      custom: ['', Validators.required],
      contenedor: ['', Validators.required],
      referencia: ['', Validators.required],
      arrived: ['', Validators.required],
      empty: [''],
      departed: [''],
      location: [''],
      total: [''],
      available: [''],
      notes: [''],
      estatus: ['', Validators.required],
      actived: ['']
    })
    this.OnSelectCostumer()
    this.OnSelectEstatusContenedor()
    this.OnViewContainer()
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
    this.ContainerForm.controls.custom.setValue(Number(json.customerId))
    this.ContainerForm.controls.custom.disable();
  }

  ngAfterViewInit () {
    this.DataContenedor.arrived.setValue(this.dateArrived.value)
    const main = <HTMLInputElement>document.getElementById('SubMenu')

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap(event => {
          console.log('show')
          main.style.display = 'block'
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500))
        })
      )
      .subscribe(val => {
        console.log('hide')
        main.style.display = 'none'
      })
  }
  ngOnDestroy (): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
    var element = document.getElementById('SubMenu')
    element.style.display = 'none'

    localStorage.setItem('header', '0')
  }
  get DataContenedor () {
    return this.ContainerForm.controls
  }

  addEventfrom (type: string, event: MatDatepickerInputEvent<Date>) {
    this.From = event.value
  }
  addEventto (type: string, event: MatDatepickerInputEvent<Date>) {
    this.To = event.value
  }
  OnViewContainer () {
    this.OnChangeLoader()

    this.ContainerListService = new ContainerListService(this._httpClient)
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true
          return this.ContainerListService!.getRepoIssuesClient(
            Number(this.checked),
            this.From,
            this.To,
            Number(json.customerId)
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false
          this.isRateLimitReached = false
          this.resultsLength = data.length

          return data
        }),
        catchError(() => {
          this.isLoadingResults = false
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true
          return observableOf([])
        })
      )
      .subscribe(data => {
        this.data = data
        this.datasourceConteiner = new MatTableDataSource(this.data)
        this.datasourceConteiner.sort = this.sortSearch
        this.datasourceConteiner.paginator = this.paginatorSearch
      })
  }

  OnEditarContainer (datos: ResponseViewContainers) {
    console.log(datos)
    this.OnChangeLoader()
    var idc = datos.Customer.split('-|')
    var cust = idc[1].replace(' ', '')
    console.log(idc,cust)
    this.update = datos.Id
    this.editar = true
    this.DataContenedor.custom.setValue(Number(cust))
    this.DataContenedor.contenedor.setValue(datos.ContainerNumber)
    this.DataContenedor.referencia.setValue(datos.ReferenceNumber)
    this.DataContenedor.location.setValue(datos.Location)
    this.DataContenedor.arrived.setValue(new Date(datos.Arrived))
    this.DataContenedor.empty.setValue(new Date(datos.Empty))
    this.DataContenedor.departed.setValue(new Date(datos.Departed))
    this.th = this.FilterStatus(datos.Status)
    this.DataContenedor.estatus.setValue(this.th[0].key)
    // SelectEstatusthis.=datos.Status;
    this.DataContenedor.total.setValue(datos.Pieces)
    this.DataContenedor.available.setValue(datos.Available)
    this.DataContenedor.notes.setValue(datos.Notes)
    this.DataContenedor.actived.setValue(datos.Active)

    this.ViewTab = new FormControl(1)
    this.OnSelectItemsContainer();
  }
  OnNewContainer (dataTipo: any) {
    if (this.ContainerForm.invalid) {
      return
    }
    this.OnChangeLoader()
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this.newContainer = {
      tblCustomerID: this.DataContenedor.custom.value,
      containerNumber: this.DataContenedor.contenedor.value,
      referenceNumber: this.DataContenedor.referencia.value,
      arrivedDate: this.DataContenedor.arrived.value,
      emptyDate: this.DataContenedor.empty.value || null,
      departedDate: this.DataContenedor.departed.value || null,
      tblWarehouseContainerStatusID: this.DataContenedor.estatus.value,
      warehouseLocation: this.DataContenedor.location.value || ' ',
      pieces: this.DataContenedor.total.value || 1,
      available: this.DataContenedor.available.value || 1,
      notes: this.DataContenedor.notes.value || ' ',
      active: Number(this.DataContenedor.actived.value),
      tipo: Number(dataTipo),
      po:''
    }

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Containers/ContainersNew`,
        this.newContainer,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log('respuesta', response)
        var txt = String(response.responses)
        if (txt.includes('insert-')) {
          this.update = txt.replace('insert-', '')
          this.editar = true
          this.actived = true
          this.OnSelectItemsContainer();
        } else if (txt.includes('update-')) {
          this.update = txt.replace('update-', '')
          this.editar = true;
          this.OnSelectItemsContainer();
        }
        //this.OnCancel();

        //      this.OnViewContainer();
      })
  }

  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.CustomerView = response
      })
  }
  OnSelectEstatusContenedor () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Containers/ContainersViewEstaus`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayEstatusContenedor = response
      })
  }
  isSelected (index: number) {
    if (index == 0 && this.update != null) {
      return true
    } else {
      return false
    }
  }
  OnCancel () {
    this.update = null
    this.editar = false
    this.selected = null
    this.DataContenedor.contenedor.setValue('')
    this.DataContenedor.referencia.setValue('')
    this.DataContenedor.arrived.setValue(new Date())
    this.DataContenedor.empty.setValue(new Date())
    this.DataContenedor.departed.setValue(new Date())
    // this.SelectEstatus=datos.Status;
    this.DataContenedor.total.setValue(0)
    this.DataContenedor.available.setValue(0)
    this.DataContenedor.notes.setValue('')
    this.actived = false

    this.ViewTab = new FormControl(0)
  }
  OnChangeLoader () {
    this.spinner.show()

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide()
    }, 5000)
  }
  FilterStatus (locationName: string) {
    return this.ArrayEstatusContenedor.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }
  @ViewChild('exportExcel') table: ElementRef
  exportAsExcel () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  datosLector: Lector

  applyFilterSearch (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.datasourceConteiner.filter = filterValue.trim().toLowerCase()

    if (this.datasourceConteiner.paginator) {
      this.datasourceConteiner.paginator.firstPage()
    }
  }
  openDialogLector (): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      this.DataContenedor.filter = result.Resultado.trim().toLowerCase()

      if (this.datasourceConteiner.paginator) {
        this.datasourceConteiner.paginator.firstPage()
      }
    })
  }

  onAddItemsContainer () {
    var js = {
      containerId: Number(this.update),
      locationId: 0,
      itemNumber: String(this.FormItemsContainer.controls.itemNumber.value),
      quantity: Number(this.FormItemsContainer.controls.quantity.value),
      receiveQuantity: 0,
      palletQuantity: Number(this.FormItemsContainer.controls.pallet.value),
      weight: Number(this.FormItemsContainer.controls.weight.value),
      active: 1,
         proNumber:String(this.FormItemsContainer.controls.proNumber.value)
    }


    this._httpClient
    .post<any>(
      `${environment.apiUrl}/Containers/ContainersItemsNew`,
     js,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
this.OnSelectItemsContainer();

    });
  }

  OnSelectItemsContainer(){
    this.viewTable=false;
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Containers/containerreceiveitemsSelect?ContainerID=${Number(this.update)}`,
     
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
this.arrayItemsContainer=response;
this.viewTable=true;
    });
  }

  OnDeleteItemsContainer(Data:any){

    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Containers/containerreceiveitemsDeletet?ContainerID=${Number(Data.receiveItemsID)}`,
     
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
this.OnSelectItemsContainer();
    });
  }

  OnEditarItemsContainer(Datas:any){

this.EditItemsContainerID=Datas.receiveItemsID;
this.FormItemsContainer.controls.itemNumber.setValue(String(Datas.ItemNumber))
this.FormItemsContainer.controls.quantity.setValue(Number(Datas.Quantity))
this.FormItemsContainer.controls.pallet.setValue(Number(Datas.palletQuantity))
this.FormItemsContainer.controls.weight.setValue(Number(Datas.weightTotal))
this.FormItemsContainer.controls.proNumber.setValue(String(Datas.proNumber))
this.viewEditItemsContainer=true;
  }
  onUpdateItemsContainer () {
    var js = {
      containerId: Number(this.update),
      locationId: 0,
      itemNumber: String(this.FormItemsContainer.controls.itemNumber.value),
      quantity: Number(this.FormItemsContainer.controls.quantity.value),
      receiveQuantity: 0,
      palletQuantity: Number(this.FormItemsContainer.controls.pallet.value),
      weight: Number(this.FormItemsContainer.controls.weight.value),
      active: 1,
      proNumber:String(this.FormItemsContainer.controls.proNumber.value)
    }


    this._httpClient
    .post<any>(
      `${environment.apiUrl}/Containers/ContainersItemsUpdate?ID=${Number(this.EditItemsContainerID)}`,
     js,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
this.OnSelectItemsContainer();
this.viewEditItemsContainer=false;
this.FormItemsContainer.reset();
    });
  }

  OnConfirmItemsContainer (datos: ResponseViewContainers) {
    console.log(datos)
   
    this.update = datos.Id
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Containers/containerreceiveitemsSelect?ContainerID=${Number(this.update)}`,
     
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
      console.log(datos)
      const dialogRef = this.dialog.open(ConfirmContainerItemsComponent, {
        width: '100vw',
       height:'100vh',
        data: {container: datos, arrayitems: response},
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
       // this.animal = result;
      });
    });
  }
  onCleaarte(da:string){
    var text='';
   try {
    var idc = da.split('-|')
    var cust = idc[0].replace('', '')
    text=cust
   } catch (error) {
    text=da;
   }
   return text

  }

}